import React from 'react';
var CrossIconSvg = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 33 32" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.793 4.293a1 1 0 0 1 1.414 0L16.5 14.586 26.793 4.293a1 1 0 1 1 1.414 1.414L17.914 16l10.293 10.293a1 1 0 0 1-1.414 1.414L16.5 17.414 6.207 27.707a1 1 0 0 1-1.414-1.414L15.086 16 4.793 5.707a1 1 0 0 1 0-1.414Z", fill: "currentColor" })));
};
export default CrossIconSvg;
